import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { BaseMessageSignerWalletAdapter, pollUntilReady, WalletConnectionError, WalletDisconnectionError, WalletError, WalletNotConnectedError, WalletNotFoundError, WalletPublicKeyError, WalletSignTransactionError } from '@solana/wallet-adapter-base';
import { PublicKey } from '@solana/web3.js';
import bs58 from 'bs58';
export var SlopeWalletAdapter = /*#__PURE__*/function (_BaseMessageSignerWal) {
  _inherits(SlopeWalletAdapter, _BaseMessageSignerWal);

  var _super = _createSuper(SlopeWalletAdapter);

  function SlopeWalletAdapter() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SlopeWalletAdapter);

    _this = _super.call(this);
    _this._connecting = false;
    _this._wallet = null;
    _this._publicKey = null;
    if (!_this.ready) pollUntilReady(_assertThisInitialized(_this), config.pollInterval || 1000, config.pollCount || 3);
    return _this;
  }

  _createClass(SlopeWalletAdapter, [{
    key: "publicKey",
    get: function get() {
      return this._publicKey;
    }
  }, {
    key: "ready",
    get: function get() {
      return typeof window !== 'undefined' && !!window.Slope;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this._connecting;
    }
  }, {
    key: "connected",
    get: function get() {
      return !!this._publicKey;
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var wallet, account, _yield$wallet$connect, data, publicKey;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(this.connected || this.connecting)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this._connecting = true;

                if (window.Slope) {
                  _context.next = 6;
                  break;
                }

                throw new WalletNotFoundError();

              case 6:
                wallet = new window.Slope();
                _context.prev = 7;
                _context.next = 10;
                return wallet.connect();

              case 10:
                _yield$wallet$connect = _context.sent;
                data = _yield$wallet$connect.data;

                if (data.publicKey) {
                  _context.next = 14;
                  break;
                }

                throw new WalletConnectionError();

              case 14:
                account = data.publicKey;
                _context.next = 22;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](7);

                if (!(_context.t0 instanceof WalletError)) {
                  _context.next = 21;
                  break;
                }

                throw _context.t0;

              case 21:
                throw new WalletConnectionError(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message, _context.t0);

              case 22:
                _context.prev = 22;
                publicKey = new PublicKey(account);
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context["catch"](22);
                throw new WalletPublicKeyError(_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message, _context.t1);

              case 29:
                this._wallet = wallet;
                this._publicKey = publicKey;
                this.emit('connect');
                _context.next = 38;
                break;

              case 34:
                _context.prev = 34;
                _context.t2 = _context["catch"](0);
                this.emit('error', _context.t2);
                throw _context.t2;

              case 38:
                _context.prev = 38;
                this._connecting = false;
                return _context.finish(38);

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 34, 38, 41], [7, 17], [22, 26]]);
      }));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var wallet, _yield$wallet$disconn, msg;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                wallet = this._wallet;

                if (!wallet) {
                  _context2.next = 17;
                  break;
                }

                this._wallet = null;
                this._publicKey = null;
                _context2.prev = 4;
                _context2.next = 7;
                return wallet.disconnect();

              case 7:
                _yield$wallet$disconn = _context2.sent;
                msg = _yield$wallet$disconn.msg;

                if (!(msg !== 'ok')) {
                  _context2.next = 11;
                  break;
                }

                throw new WalletDisconnectionError(msg);

              case 11:
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](4);

                if (!(_context2.t0 instanceof WalletError)) {
                  // eslint-disable-next-line no-ex-assign
                  _context2.t0 = new WalletDisconnectionError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message, _context2.t0);
                }

                this.emit('error', _context2.t0);

              case 17:
                this.emit('disconnect');

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 13]]);
      }));
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var wallet, message, _yield$wallet$signTra, msg, data, publicKey, signature;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context3.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context3.prev = 4;
                message = bs58.encode(transaction.serializeMessage());
                _context3.next = 8;
                return wallet.signTransaction(message);

              case 8:
                _yield$wallet$signTra = _context3.sent;
                msg = _yield$wallet$signTra.msg;
                data = _yield$wallet$signTra.data;

                if (!(!data.publicKey || !data.signature)) {
                  _context3.next = 13;
                  break;
                }

                throw new WalletSignTransactionError(msg);

              case 13:
                publicKey = new PublicKey(data.publicKey);
                signature = bs58.decode(data.signature);
                transaction.addSignature(publicKey, signature);
                return _context3.abrupt("return", transaction);

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](4);

                if (!(_context3.t0 instanceof WalletError)) {
                  _context3.next = 23;
                  break;
                }

                throw _context3.t0;

              case 23:
                throw new WalletSignTransactionError(_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message, _context3.t0);

              case 24:
                _context3.next = 30;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t1 = _context3["catch"](0);
                this.emit('error', _context3.t1);
                throw _context3.t1;

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 26], [4, 19]]);
      }));
    }
  }, {
    key: "signAllTransactions",
    value: function signAllTransactions(transactions) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var wallet, messages, _yield$wallet$signAll, msg, data, length, publicKey, i;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context4.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context4.prev = 4;
                messages = transactions.map(function (transaction) {
                  return bs58.encode(transaction.serializeMessage());
                });
                _context4.next = 8;
                return wallet.signAllTransactions(messages);

              case 8:
                _yield$wallet$signAll = _context4.sent;
                msg = _yield$wallet$signAll.msg;
                data = _yield$wallet$signAll.data;
                length = transactions.length;

                if (!(!data.publicKey || ((_a = data.signatures) === null || _a === void 0 ? void 0 : _a.length) !== length)) {
                  _context4.next = 14;
                  break;
                }

                throw new WalletSignTransactionError(msg);

              case 14:
                publicKey = new PublicKey(data.publicKey);

                for (i = 0; i < length; i++) {
                  transactions[i].addSignature(publicKey, bs58.decode(data.signatures[i]));
                }

                return _context4.abrupt("return", transactions);

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](4);

                if (!(_context4.t0 instanceof WalletError)) {
                  _context4.next = 23;
                  break;
                }

                throw _context4.t0;

              case 23:
                throw new WalletSignTransactionError(_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message, _context4.t0);

              case 24:
                _context4.next = 30;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t1 = _context4["catch"](0);
                this.emit('error', _context4.t1);
                throw _context4.t1;

              case 30:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 26], [4, 19]]);
      }));
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var wallet, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context5.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context5.prev = 4;
                _context5.next = 7;
                return wallet.signMessage(message);

              case 7:
                response = _context5.sent;
                return _context5.abrupt("return", bs58.decode(response.data.signature));

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](4);
                throw new WalletSignTransactionError(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message, _context5.t0);

              case 14:
                _context5.next = 20;
                break;

              case 16:
                _context5.prev = 16;
                _context5.t1 = _context5["catch"](0);
                this.emit('error', _context5.t1);
                throw _context5.t1;

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 16], [4, 11]]);
      }));
    }
  }]);

  return SlopeWalletAdapter;
}(BaseMessageSignerWalletAdapter);